<template>
  <div>
    <div v-if="is_active">
      <div class="activeUserAvatar">{{ showUpperLetters }}</div>
    </div>
    <div v-else>
      <div class="userAvatar">{{ showUpperLetters }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserAvatar',
  props: {
    first_name: {},
    last_name: {},
    active: {
      default: false,
    },
  },
  data: function () {
    return {
      is_active: false,
    };
  },
  computed: {
    showUpperLetters: function () {
      if (this.first_name && this.last_name) {
        return this.first_name.charAt(0) + this.last_name.charAt(0);
      }
    },
  },
  watch: {
    active: function (val) {
      this.is_active = val;
    },
  },
  mounted: function () {
    // this.setActive()
  },
  methods: {
    setActive: function () {
      this.is_active = this.active;
      console.log('I am in UserAvatar:', this.is_active);
    },
  },
};
</script>

<style scoped>
.userAvatar {
  width: 2.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
  border-radius: 1.25rem;
  background: var(--bc_indiaInk);
  color: var(--bc_red);
  text-align: center;
}
.activeUserAvatar {
  width: 2.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
  border-radius: 1.25rem;
  background: var(--bc_red);
  color: var(--bc_indiaInk);
  text-align: center;
}
</style>
